import { useRecordContext, useTranslate } from 'react-admin';
import { Box, Typography, Avatar, Chip } from '@mui/material';
import type { Contact } from '../../../types/chat.types';

export const ContactHeader = () => {
  const record = useRecordContext<Contact>();
  const translate = useTranslate();
  if (!record) return null;

  return (
    <Box display="flex" alignItems="center" gap={2} mb={3}>
      <Avatar sx={{ width: 64, height: 64, bgcolor: 'primary.main', fontSize: 28 }}>
        {record.name?.[0]?.toUpperCase() || record.email?.[0]?.toUpperCase() || '?'}
      </Avatar>
      <Box>
        <Typography variant="h5">{record.name || translate('resources.contact.unknownContact')}</Typography>
        {record.email && (
          <Typography variant="body2" color="textSecondary">
            {record.email}
          </Typography>
        )}
        {record.mergedIntoContactId && (
          <Box display="flex" gap={1} mt={1}>
            <Chip label={translate('resources.contact.merged')} size="small" color="warning" variant="outlined" />
          </Box>
        )}
      </Box>
    </Box>
  );
};
